import { render, staticRenderFns } from "./SideBarComments.vue?vue&type=template&id=76df3b04&scoped=true&"
import script from "./SideBarComments.vue?vue&type=script&lang=js&"
export * from "./SideBarComments.vue?vue&type=script&lang=js&"
import style0 from "./SideBarComments.vue?vue&type=style&index=0&id=76df3b04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76df3b04",
  null
  
)

export default component.exports